import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ReactPlayerProps } from 'react-player';
import { useSelector } from 'react-redux';
import { selectLocale } from 'models/localization';
import { LocalizableVideo, LocalizableImage } from 'models/cms/common/types';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import getVideoUrlByLocale from 'models/helpers/getVideoUrlByLocale';
import ReactPlayerAutoplay from 'components/ReactPlayerAutoplay';

const BoothVideoContainer = styled.div`
  width: 100%;
  min-height: 100px;
  margin: 12px 0;
`;

const BoothVideo = ({ video, thumbnail }: {
  video: LocalizableVideo;
  thumbnail: LocalizableImage;
}) => {
  const locale = useSelector(selectLocale);
  const thumbnailUrl = findAvailableLocale(thumbnail, locale)?.originalImageUrl;
  const videoUrl = getVideoUrlByLocale(video, locale);
  const features = useSelector((s: any) => s.eventConfigs.features);
  const autoplay = useMemo(() => features.includes('boothTabVideoAutoplay'), [features]);

  const propsOverride = useMemo(() => ({
    config: {},
    style: { zIndex: 100, backgroundColor: 'black' },
  } as ReactPlayerProps), []);
  if (!videoUrl) return null;
  return (
    <BoothVideoContainer>
      <ReactPlayerAutoplay
        videoUrl={videoUrl}
        thumbnailUrl={thumbnailUrl}
        autoPlay={autoplay}
        defaultPropsOverride={propsOverride}
      />
    </BoothVideoContainer>
  );
};

export default BoothVideo;
